import { H3 } from '@berlitz/globals'
import EmptyState from '@components/EmptyState'
import { ProgramStudentInfo } from '@interfaces/Student'
import { EmptySpan } from '@layouts/Scheduling/ScheduleOptions/style'
import React from 'react'
import { FormattedMessage } from 'react-intl'

const InvalidProgramStatus: React.FC<ProgramStudentInfo> = ({ Status, customTitle = '', customBody = '' }) => (
  <EmptyState
    customHeading={
      <H3>
        <FormattedMessage id={customTitle || 'You cannot book lessons as your program has been set to'} />{' '}
        {!customTitle && (
          <>
            <EmptySpan>{Status}</EmptySpan>.
          </>
        )}
      </H3>
    }
    img="/images/locked.svg"
    bodyTxt={
      customBody || 'Please contact your learning center for more information, or raise a case using the button below.'
    }
    linkUrl="/support/contact-us/?id=technical-support"
    btnTxt="Raise a case"
    top="md"
  />
)

export default InvalidProgramStatus
